import { Col,  Row } from "reactstrap";
import { H3, P } from "../../../AbstractElements";
import InvoiceHeaderCol from "./InvoiceHeaderCol";
import { InvoiceHash } from "../../../Constant";
import CountUp from 'react-countup';

const InvoiceHeader = () => {
  return (
    <div>
      <Row className="invo-header">
        <InvoiceHeaderCol/>
        <Col sm="6">
          <div className="text-md-end text-xs-center">
            <H3>{InvoiceHash}
            <CountUp end={1069} />
            </H3>
            <P>Issued May<span className="digits"> 16, 2023</span><br />Payment Due <span className="digits"> 20, 2023</span></P>
          </div>
        </Col>
      </Row>
      <hr/>
    </div>
  );
};
export default InvoiceHeader;
